import React from 'react'

export default props => (
  <svg viewBox="0 0 14 20" {...props}>
    <path d="M7,0 C3.14,0 0,3.14 0,7 C0,12.25 7,20 7,20 C7,20 14,12.25 14,7 C14,3.14 10.86,0 7,0 Z M7,2 C8.1,2 9,2.9 9,4 C9,5.11 8.1,6 7,6 C5.9,6 5,5.11 5,4 C5,2.9 5.9,2 7,2 Z M7,12 C5.33,12 3.86,11.1904762 3,9.95238095 C3.02,8.6952381 5.67,8 7,8 C8.33,8 10.98,8.6952381 11,9.95238095 C10.14,11.1904762 8.67,12 7,12 Z" />
  </svg>
)
